import { investmentConstants } from "../_constants/investment.constant";

import {
  historiesChangePage,
  dividendsData,
  dividendsError,
  filterMonthlyReturn,
  transformOrderData,
  duplicateNumber,
} from "../_utils/investment.utils";
import { setIsFetching } from "../_utils/general.utils";

import { sub } from "date-fns";
import { nanoid } from "nanoid";

let newDate = new Date();

const initialState = {
  userAccounts: [],
  investSearch: false,
  isFetching: false,
  activedFunds: {
    funds: [],
    isFetching: false,
    errorMessage: null,
  },
  allFunds: {
    funds: [],
    isFetching: false,
    errorMessage: null,
  },
  allFundCodes: {
    funds: [],
    isFetching: false,
    errorMessage: null,
  },
  lot: {
    tableHeaders: [
      {
        header: "วันที่",
        sortKey: "priceDate",
      },
      {
        header: "กองทุน",
        sortKey: "fundName",
      },
      {
        header: "กราฟตั้งแต่วันที่ลงทุน",
        sortKey: "chart",
      },
      {
        header: "เงินลงทุน",
        sortKey: "invest",
      },
      {
        header: "มูลค่าปัจจุบัน",
        sortKey: "value",
      },
      {
        header: "ราคาทุน",
        sortKey: "averagePrice",
      },
      {
        header: "ราคาปัจจุบัน",
        sortKey: "currentPrice",
      },
      {
        header: "P/L",
        sortKey: "pAndL",
      },
      {
        header: "%Port",
        sortKey: "portPercent",
      },
      {
        header: "%Yield",
        sortKey: "yieldPercent",
      },
    ],
    groupTypeList: [
      {
        name: "ประเภทบัญชี",
        value: "ACCOUNT_TYPE",
      },
      {
        name: "ประเภทกองทุน",
        value: "CATEGORY",
      },
      {
        name: "รายปี",
        value: "YEAR",
      },
      {
        name: "รายบลจ.",
        value: "COMPANY",
      },
    ],
    queries: {
      fundType: {
        name: "ทั้งหมด",
        value: "ALL",
      },
      groupType: {
        name: "รายปี",
        value: "YEAR",
      },
      fundCode: null,
    },
    response: {
      isFetching: false,
      data: [],
      errorMessage: null,
    },
    navs: {
      isFetching: false,
      data: [],
      errorMessage: null,
    },
    fundList: [],
  },
  history: {
    columnList: [
      {
        header: "Code",
        sortKey: "code",
      },
      {
        header: "ทำรายการ",
        sortKey: "date-list",
      },
      {
        header: "กองทุน",
        sortKey: "fund-name",
      },
      {
        header: "Activity",
        sortKey: "activity",
      },
      {
        header: "ยอดเงิน",
        sortKey: "balance",
      },
      {
        header: "จำนวนหน่วย",
        sortKey: "unit",
      },
      {
        header: "Nav",
        sortKey: "nav",
      },
      {
        header: "Status",
        sortKey: "status",
      },
      {
        header: "Payment",
        sortKey: "payment",
      },
      {
        header: "วันรับเงิน",
        sortKey: "received-date",
      },
      {
        header: "Remark",
        sortKey: "remark",
      },
      {
        header: "Order#",
        sortKey: "order-number",
      },
    ],
    table: {
      header: "Group Name",
      headers: [
        {
          header: "Code",
          sortKey: "code",
        },
        {
          header: "ทำรายการ",
          sortKey: "date-list",
        },
        {
          header: "กองทุน",
          sortKey: "fund-name",
        },
        {
          header: "Activity",
          sortKey: "activity",
        },
        {
          header: "ยอดเงิน",
          sortKey: "balance",
        },
        {
          header: "จำนวนหน่วย",
          sortKey: "unit",
        },
        {
          header: "Nav",
          sortKey: "nav",
        },
        {
          header: "Status",
          sortKey: "status",
        },
        {
          header: "Payment",
          sortKey: "payment",
        },
        {
          header: "วันรับเงิน",
          sortKey: "received-date",
        },
        {
          header: "Remark",
          sortKey: "remark",
        },
        {
          header: "Order#",
          sortKey: "order-number",
        },
      ],
    },
    remarkList: [
      {
        name: "ทั้งหมด",
        value: "",
      },
      {
        name: "มี Remark",
        value: "True",
      },
      {
        name: "ไม่มี Remark",
        value: "False",
      },
    ],
    statusList: [
      {
        name: "ทั้งหมด",
        value: "",
      },
      {
        name: "Complete",
        value: "C",
      },
      {
        name: "On Process",
        value: "P",
      },
      {
        name: "Canceled",
        value: "X",
      },
      {
        name: "Rejected",
        value: "R",
      },
    ],
    queries: {
      fundType: {
        name: "ทั้งหมด",
        value: "ALL",
      },
      groupType: {
        name: "ประเภทบัญชี",
        value: "ACCOUNT_TYPE",
      },
      funds: [],
      date: {
        startDate: sub(newDate, { years: 1 }).toJSON(),
        endDate: newDate.toJSON(),
      },
      sortBy: null,
      sortType: "d",
      remark: "",
      status: "",
    },
    response: {
      isFetching: false,
      data: [],
      currentPage: 1,
      totalPage: 1,
      errorMessage: null,
    },
  },
  dca: {
    columnList: [
      {
        header: "Code",
        sortKey: "accountNumber",
      },
      {
        header: "เริ่ม",
        sortKey: "tradeDate",
      },
      {
        header: "สิ้นสุด",
        sortKey: "endDate",
      },
      {
        header: "Activity",
        sortKey: "tradeType",
      },
      {
        header: "กองทุน",
        sortKey: "fundName",
      },
      {
        header: "แผนลงทุน",
        sortKey: "savingPlan",
      },
      {
        header: "จำนวน",
        sortKey: "amount",
      },
      {
        header: "Payment",
        sortKey: "payment",
      },
      {
        header: "วันที่ส่งคำสั่ง",
        sortKey: "entryDate",
      },
    ],
    tradeTypeList: [
      {
        name: "ทั้งหมด",
        value: "",
      },
      {
        name: "Buy",
        value: "B",
      },
      // {
      //   name: 'Sell',
      //   value: 'S'
      // },
      {
        name: "Switch",
        value: "W",
      },
    ],
    statusList: [
      {
        name: "ทั้งหมด",
        value: "",
      },
      {
        name: "มีผลอยู่",
        value: true,
      },
      {
        name: "หมดอายุ",
        value: false,
      },
    ],
    queries: {
      funds: [],
      sortBy: null,
      sortType: "a",
      tradeType: { name: "ทั้งหมด", value: "" },
      status: { name: "มีผลอยู่", value: "true" },
    },
    response: {
      isFetching: false,
      data: [],
      errorMessage: null,
    },
  },
  book: {
    queries: {
      funds: [],
      date: {
        startDate: sub(newDate, { years: 1 }).toJSON(),
        endDate: newDate.toJSON(),
      },
    },
    response: {
      isFetching: false,
      data: undefined,
      errorMessage: null,
    },
    tableHeaders: [
      {
        header: "วันที่",
        sortKey: "date",
      },
      {
        header: "ยอดเงิน",
        sortKey: "investValue",
      },
      {
        header: "หน่วย",
        sortKey: "investUnit",
      },
      {
        header: "ยอดเงิน",
        sortKey: "sellValue",
      },
      {
        header: "หน่วย",
        sortKey: "sellUnit",
      },
      {
        header: "NAV",
        sortKey: "nav",
      },
      {
        header: "P/L",
        sortKey: "pAndL",
      },
      {
        header: "ปันผล",
        sortKey: "dividend",
      },
      {
        header: "หน่วยคงเหลือ",
        sortKey: "balanceUnit",
      },
      {
        header: "มูลค่าคงเหลือ",
        sortKey: "balanceValue",
      },
    ],
  },
  dividend: {
    queries: {
      funds: [],
      sortType: "d",
      sortBy: null,
      date: {
        startDate: sub(newDate, { years: 1 }).toJSON(),
        endDate: newDate.toJSON(),
      },
    },
    dividends: null,
    isFetching: false,
    errorMessage: undefined,
    table: {
      header: "Group Name",
      headers: [
        {
          header: "Code",
          sortKey: "accountNumber",
        },
        {
          header: "กองทุน",
          sortKey: "fundCode",
        },
        {
          header: "วันปิดสมุดทะเบียน",
          sortKey: "xDate",
        },
        {
          header: "วันจ่ายเงินปันผล",
          sortKey: "payDate",
        },
        {
          header: "จำนวนหน่วย",
          sortKey: "unit",
        },
        {
          header: "ปันผลต่อหน่วย",
          sortKey: "rate",
        },
        {
          header: "ยอดเงินปันผล",
          sortKey: "amount",
        },
        {
          header: "หักภาษี",
          sortKey: "tax",
        },
        {
          header: "ยอดเงินสุทธิ",
          sortKey: "net",
        },
      ],
    },
  },
  portfolio: {
    queries: {
      sortType: "d",
      sortKey: null,
      dateType: "1Y",
      groupType: "ACCOUNT_TYPE",
    },
    portfolios: {
      isFetching: false,
      data: {},
      errorMessage: null,
    },
    navPortfolios: {
      isFetching: false,
      data: [],
      errorMessage: undefined,
    },
    isFetching: false,
    errorMessage: undefined,
    headers: [
      {
        header: "Code",
        sortKey: "accountNumber",
      },
      {
        header: "กองทุน",
        sortKey: "fundCode",
      },
      {
        header: "Chart",
        sortKey: "chart",
      },
      {
        header: "เงินลงทุน",
        sortKey: "investmentAmount",
      },
      {
        header: "มูลค่าปัจจุบัน",
        sortKey: "marketAmount",
      },
      {
        header: "ราคาทุนเฉลี่ย",
        sortKey: "averagePrice",
      },
      {
        header: "ราคาปัจจุบัน",
        sortKey: "nav",
      },
      {
        header: "P/L",
        sortKey: "profitLoss",
      },
      {
        header: "% Port",
        sortKey: "percentage",
      },
    ],
  },
  portfolioStatistic: {
    previousReturn: {
      isFetching: false,
      data: {},
      errorMessage: null,
    },
    historyGraph: {
      isFetching: false,
      data: [],
      errorMessage: null,
      graphModeList: [
        {
          name: "กราฟผลตอบแทนย้อนหลัง",
          value: "PREVIOUSE_RETURN",
        },
        {
          name: "กราฟมูลค่าพอร์ทย้อนหลัง",
          value: "AUM",
        },
        {
          name: "ทั้งหมด",
          value: "ALL",
        },
      ],
    },
    previousReturnGraph: {
      isFetching: false,
      data: [],
      errorMessage: null,
    },
    monthlyReturn: {
      isFetching: false,
      data: [],
      errorMessage: null,
    },
    profit: {
      isFetching: false,
      data: {},
      errorMessage: null,
    },
    volatility: {
      isFetching: false,
      data: {},
      errorMessage: null,
    },
    maxDrawdown: {
      isFetching: false,
      data: {},
      errorMessage: null,
    },
    drawdown: {
      isFetching: false,
      data: [],
      errorMessage: null,
      sortFilters: [
        {
          name: "% ติดลบ",
          value: "percentage",
        },
        {
          name: "ตามเวลา",
          value: "date",
        },
      ],
    },
    lastDate: null,
  },
  order: {
    orders: {
      isFetching: false,
      data: null,
      errorMessage: undefined,
    },
    headers: [
      {
        header: "Code",
        sortKey: "accountNumber",
      },
      {
        header: "ทำรายการ",
        sortKey: "tradeDate",
      },
      {
        header: "กองทุน",
        sortKey: "fundCode",
      },
      {
        header: "Activity",
        sortKey: "tradeType",
      },
      {
        header: "ยอดเงิน",
        sortKey: "amount",
      },
      {
        header: "จำนวนหน่วย",
        sortKey: "unit",
      },
      {
        header: "Status",
        sortKey: "status",
      },
      {
        header: "Payment",
        sortKey: "bankPayment",
      },
      {
        header: "วันรับเงิน",
        sortKey: "tradeDate",
      },
      {
        header: "Remark",
        sortKey: "remark",
      },
      {
        header: "Order#",
        sortKey: "number",
      },
    ],
    queries: {
      status: null,
      tradeType: null,
      remark: null,
      sortType: "a",
      sortBy: null,
    },
  },
  information: {},
};

const investmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case investmentConstants.SET_INVEST_SEARCH: {
      return {
        ...state,
        investSearch: action.payload,
      };
    }

    case investmentConstants.UPDATE_USER_ACCOUNTS: {
      return {
        ...state,
        userAccounts: action.payload ?? [],
      };
    }

    // Investment Histories
    case investmentConstants.UPDATE_INVESTMENT_HISTORIES_QUERIES: {
      if (!action.payload || !Object.keys(action.payload).length) {
        return state;
      }

      let updateAttribute = {};
      Object.keys(action.payload).forEach((attribute) => {
        let value = action.payload[`${attribute}`];
        switch (attribute) {
          case "sortBy":
            if (value === "nav" || value === "riskLevel") {
              updateAttribute["sortType"] =
                state.history.queries.sortBy === value &&
                state.history.queries.sortType !== "d"
                  ? "d"
                  : "a";
            } else {
              updateAttribute["sortType"] =
                state.history.queries.sortBy === value &&
                value &&
                state.history.queries.sortType !== "a"
                  ? "a"
                  : "d";
            }
            updateAttribute["sortBy"] = value;
            break;
          default:
            updateAttribute[attribute] = value;
            break;
        }
      });

      return {
        ...state,
        history: {
          ...state.history,
          queries: {
            ...state.history.queries,
            ...updateAttribute,
          },
          response: {
            ...state.history.response,
            currentPage: 1,
          },
        },
      };
    }
    case investmentConstants.FETCH_ACTIVED_FUNDS_START: // need to recheck with line 689
      return {
        ...state,
        activedFunds: {
          ...state.activedFunds,
          isFetching: true,
        },
      };
    case investmentConstants.FETCH_ACTIVED_FUNDS_SUCCESS:
      return {
        ...state,
        activedFunds: {
          ...state.activedFunds,
          funds: action.payload?.length !== 0 ? action.payload : [],
          isFetching: false,
        },
      };
    case investmentConstants.FETCH_ACTIVED_FUNDS_FAILURE:
      return {
        ...state,
        activedFunds: {
          ...state.activedFunds,
          funds: [],
          errorMessage: action.payload,
          isFetching: false,
        },
      };
    case investmentConstants.FETCH_ALL_FUNDS_START: // need to recheck with line 689
      return {
        ...state,
        allFunds: {
          ...state.allFunds,
          isFetching: true,
        },
      };
    case investmentConstants.FETCH_ALL_FUNDS_SUCCESS:
      return {
        ...state,
        allFunds: {
          ...state.allFunds,
          funds: action.payload?.length !== 0 ? action.payload : [],
          isFetching: false,
        },
      };
    case investmentConstants.FETCH_ALL_FUNDS_FAILURE:
      return {
        ...state,
        allFunds: {
          ...state.allFunds,
          funds: [],
          errorMessage: action.payload,
          isFetching: false,
        },
      };
    case investmentConstants.FETCH_ALL_FUND_CODES_START:
      return {
        ...state,
        allFundCodes: {
          ...state.allFundCodes,
          isFetching: true,
        },
      };
    case investmentConstants.FETCH_ALL_FUND_CODES_SUCCESS:
      return {
        ...state,
        allFundCodes: {
          ...state.allFundCodes,
          funds: action.payload?.length !== 0 ? action.payload : [],
          isFetching: false,
        },
      };
    case investmentConstants.FETCH_ALL_FUND_CODES_FAILURE:
      return {
        ...state,
        allFundCodes: {
          ...state.allFundCodes,
          funds: [],
          errorMessage: action.payload,
          isFetching: false,
        },
      };
    case investmentConstants.FETCH_HISTORIES_START:
      return {
        ...state,
        history: {
          ...state.history,
          response: {
            ...state.history.response,
            isFetching: true,
          },
        },
      };
    case investmentConstants.FETCH_HISTORIES_SUCCESS:
      return {
        ...state,
        history: {
          ...state.history,
          response: {
            ...state.history.response,
            isFetching: false,
            data: transformOrderData(duplicateNumber(action.payload)) ?? [],
            errorMessage: null,
          },
        },
      };
    case investmentConstants.FETCH_HISTORIES_FAILURE:
      return {
        ...state,
        history: {
          ...state.history,
          response: {
            ...state.history.response,
            isFetching: false,
            data: [],
            errorMessage: action.payload,
          },
        },
      };
    case investmentConstants.FETCH_HISTORIES_CHANGE_PAGE:
      return {
        ...state,
        history: historiesChangePage(state.history, action.payload),
      };

    // Investment DCA
    case investmentConstants.DELETE_DCA_ORDER_REQUEST_START:
      return {
        ...state,
        dca: {
          ...state.dca,
        },
      };
    case investmentConstants.DELETE_DCA_ORDER_REQUEST_SUCCESS:
      return {
        ...state,
        dca: {
          ...state.dca,
        },
      };
    case investmentConstants.DELETE_DCA_ORDER_REQUEST_FAILURE:
      return {
        ...state,
        dca: {
          ...state.dca,
          response: {
            ...state.dca.response,
            errorMessage: action?.payload?.message,
          },
        },
      };
    case investmentConstants.CLEAR_DCA_ORDER_ERROR_MESSAGE:
      return {
        ...state,
        dca: {
          ...state.dca,
          response: {
            ...state.dca.response,
            errorMessage: null,
          },
        },
      };
    case investmentConstants.DELETE_ORDER_dca_REQUEST_FAILURE:
      return {
        ...state,
        dca: {
          ...state.dca,
        },
      };
    case investmentConstants.UPDATE_INVESTMENT_DCA_QUERIES: {
      if (!action.payload || !Object.keys(action.payload).length) {
        return state;
      }

      let updateAttribute = {};
      Object.keys(action.payload).forEach((attribute) => {
        let value = action.payload[`${attribute}`];
        switch (attribute) {
          case "sortBy":
            if (value === "nav" || value === "riskLevel") {
              updateAttribute["sortType"] =
                state.dca.queries.sortBy === value &&
                state.dca.queries.sortType !== "d"
                  ? "d"
                  : "a";
            } else {
              updateAttribute["sortType"] =
                state.dca.queries.sortBy === value &&
                value &&
                state.dca.queries.sortType !== "a"
                  ? "a"
                  : "d";
            }
            updateAttribute["sortBy"] = value;
            break;
          default:
            updateAttribute[attribute] = value;
            break;
        }
      });

      return {
        ...state,
        dca: {
          ...state.dca,
          queries: {
            ...state.dca.queries,
            ...updateAttribute,
          },
          response: {
            ...state.dca.response,
            //currentPage: 1
          },
        },
      };
    }
    case investmentConstants.FETCH_DCAS_START:
      return {
        ...state,
        dca: {
          ...state.dca,
          response: {
            ...state.dca.response,
            isFetching: true,
          },
        },
      };
    case investmentConstants.FETCH_DCAS_SUCCESS:
      return {
        ...state,
        dca: {
          ...state.dca,
          response: {
            ...state.dca.response,
            isFetching: false,
            data: action.payload ?? [],
            errorMessage: null,
          },
        },
      };
    case investmentConstants.FETCH_DCAS_FAILURE:
      return {
        ...state,
        dca: {
          ...state.dca,
          response: {
            ...state.dca.response,
            isFetching: false,
            data: [],
            errorMessage: action.payload,
          },
        },
      };

    // Order
    case investmentConstants.DELETE_ORDER_REQUEST_START:
      return {
        ...state,
      };
    case investmentConstants.DELETE_ORDER_REQUEST_SUCCESS:
      return {
        ...state,
      };
    case investmentConstants.DELETE_ORDER_REQUEST_FAILURE:
      return {
        ...state,
        order: {
          ...state.order,
          orders: {
            ...state.order.orders,
            isFetching: false,
            errorMessage: action?.payload?.message,
            data: [...state.order.orders.data],
          },
        },
      };
    case investmentConstants.FETCH_ORDERS_START:
      return {
        ...state,
        order: {
          ...state.order,
          orders: {
            ...state.order.orders,
            isFetching: true,
          },
        },
      };
    case investmentConstants.FETCH_ORDERS_SUCCESS:
      return {
        ...state,
        order: {
          ...state.order,
          orders: {
            ...state.order.orders,
            isFetching: false,
            data: transformOrderData(action.payload),
          },
        },
      };
    case investmentConstants.FETCH_ORDERS_FAILURE:
      return {
        ...state,
        order: {
          ...state.order,
          orders: {
            ...state.order.orders,
            isFetching: false,
            data: null,
          },
        },
      };
    case investmentConstants.UPDATE_ORDERS_QUERIES: {
      if (!action.payload || !Object.keys(action.payload).length) {
        return state;
      }

      let updateAttribute = {};
      Object.keys(action.payload).forEach((attribute) => {
        let value = action.payload[`${attribute}`];
        switch (attribute) {
          case "sortBy":
            if (value === "nav" || value === "riskLevel") {
              updateAttribute["sortType"] =
                state.order.queries.sortBy === value &&
                state.order.queries.sortType !== "d"
                  ? "d"
                  : "a";
            } else {
              updateAttribute["sortType"] =
                state.order.queries.sortBy === value &&
                value &&
                state.order.queries.sortType !== "a"
                  ? "a"
                  : "d";
            }
            updateAttribute["sortBy"] = value;
            break;
          default:
            updateAttribute[attribute] = value;
            break;
        }
      });

      return {
        ...state,
        order: {
          ...state.order,
          queries: {
            ...state.order.queries,
            ...updateAttribute,
          },
        },
      };
    }
    case investmentConstants.CLEAR_ORDER_ERROR_MESSAGE:
      return {
        ...state,
        order: {
          ...state.order,
          orders: {
            ...state.order.orders,
            errorMessage: undefined,
          },
        },
      };
    // PORTFOLIOS
    case investmentConstants.UPDATE_PORTFOLIOS_QUERIES: {
      let { key, value } = action.payload;
      let updateAttribute = {};

      switch (key) {
        case "accountNumber":
          updateAttribute[key] = value;
          break;
        case "sortKey":
          updateAttribute = {
            sortKey: value,
            sortType:
              value &&
              value === state.portfolio.queries.sortKey &&
              state.portfolio.queries.sortType !== "a"
                ? "a"
                : "d",
          };
          break;
        default:
          updateAttribute[key] = value;
          break;
      }

      return {
        ...state,
        portfolio: {
          ...state.portfolio,
          queries: {
            ...state.portfolio.queries,
            ...updateAttribute,
          },
        },
      };
    }
    case investmentConstants.FETCH_PORTFOLIOS_START:
      return {
        ...state,
        portfolio: {
          ...state.portfolio,
          isFetching: true,
          portfolios: setIsFetching(state.portfolio.portfolios),
        },
      };
    case investmentConstants.FETCH_PORTFOLIOS_SUCCESS:
      return {
        ...state,
        portfolio: {
          ...state.portfolio,
          isFetching: false,
          portfolios: {
            isFetching: false,
            data: action.payload
              ? {
                  ...action.payload,
                  categories: action.payload.categories.map((group) => ({
                    ...group,
                    items: group.items.map((fund) => ({
                      ...fund,
                      id: nanoid(),
                    })),
                  })),
                }
              : {},
            errorMessage: null,
          },
        },
      };
    case investmentConstants.FETCH_PORTFOLIOS_FAILURE:
      return {
        ...state,
        portfolio: {
          ...state.portfolio,
          isFetching: false,
          portfolios: {
            isFetching: false,
            data: {},
            errorMessage: action.payload,
          },
        },
      };
    case investmentConstants.FETCH_NAV_PORTFOLIO_START:
      return {
        ...state,
        portfolio: {
          ...state.portfolio,
          navPortfolios: {
            ...state.portfolio.navPortfolios,
            isFetching: true,
          },
        },
      };
    case investmentConstants.FETCH_NAV_PORTFOLIO_SUCCESS:
      return {
        ...state,
        portfolio: {
          ...state.portfolio,
          navPortfolios: {
            ...state.portfolio.navPortfolios,
            isFetching: false,
            data: action.payload ?? [],
            errorMessage: null,
          },
        },
      };
    case investmentConstants.FETCH_NAV_PORTFOLIO_FAILURE:
      return {
        ...state,
        portfolio: {
          ...state.portfolio,
          navPortfolios: {
            ...state.portfolio.navPortfolios,
            isFetching: false,
            data: [],
            errorMessage: action.payload,
          },
        },
      };
    case investmentConstants.FETCH_PREVIOUS_RETURN_BY_ACCOUNT_START:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          previousReturn: setIsFetching(
            state.portfolioStatistic.previousReturn,
            {}
          ),
        },
      };
    case investmentConstants.FETCH_PREVIOUS_RETURN_BY_ACCOUNT_SUCCESS:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          previousReturn: {
            ...state.portfolioStatistic.previousReturn,
            data: action.payload,
            isFetching: false,
          },
        },
      };
    case investmentConstants.FETCH_PREVIOUS_RETURN_BY_ACCOUNT_FAILURE:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          previousReturn: {
            ...state.portfolioStatistic.previousReturn,
            data: {},
            errorMessage: action.payload,
            isFetching: false,
          },
        },
      };
    case investmentConstants.FETCH_HISTORY_GRAPH_BY_ACCOUNT_START:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          historyGraph: {
            ...state.portfolioStatistic.historyGraph,
            isFetching: true,
            data: [],
          },
        },
      };
    case investmentConstants.FETCH_HISTORY_GRAPH_BY_ACCOUNT_SUCCESS:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          historyGraph: {
            ...state.portfolioStatistic.historyGraph,
            data: action.payload,
            isFetching: false,
          },
        },
      };
    case investmentConstants.FETCH_HISTORY_GRAPH_BY_ACCOUNT_FAILURE:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          historyGraph: {
            ...state.portfolioStatistic.historyGraph,
            data: [],
            errorMessage: action.payload,
            isFetching: false,
          },
        },
      };
    case investmentConstants.FETCH_MONTHLY_RETURN_BY_ACCOUNT_START:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          monthlyReturn: {
            ...state.portfolioStatistic.monthlyReturn,
            isFetching: true,
            data: [],
          },
        },
      };
    case investmentConstants.FETCH_MONTHLY_RETURN_BY_ACCOUNT_SUCCESS:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          monthlyReturn: {
            ...state.portfolioStatistic.monthlyReturn,
            data: filterMonthlyReturn(action.payload),
            isFetching: false,
          },
        },
      };
    case investmentConstants.FETCH_MONTHLY_RETURN_BY_ACCOUNT_FAILURE:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          monthlyReturn: {
            ...state.portfolioStatistic.monthlyReturn,
            data: [],
            errorMessage: action.payload,
            isFetching: false,
          },
        },
      };
    case investmentConstants.FETCH_PREVIOUS_RETURN_GRAPH_BY_ACCOUNT_START:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          previousReturnGraph: {
            ...state.portfolioStatistic.previousReturnGraph,
            isFetching: true,
            data: [],
          },
        },
      };
    case investmentConstants.FETCH_PREVIOUS_RETURN_GRAPH_BY_ACCOUNT_SUCCESS:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          previousReturnGraph: {
            ...state.portfolioStatistic.previousReturnGraph,
            data: action.payload,
            isFetching: false,
          },
        },
      };
    case investmentConstants.FETCH_PREVIOUS_RETURN_GRAPH_BY_ACCOUNT_FAILURE:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          previousReturnGraph: {
            ...state.portfolioStatistic.previousReturnGraph,
            data: [],
            errorMessage: action.payload,
            isFetching: false,
          },
        },
      };
    case investmentConstants.FETCH_PROFIT_BY_ACCOUNT_START:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          profit: {
            ...state.portfolioStatistic.profit,
            isFetching: true,
            data: {},
          },
        },
      };
    case investmentConstants.FETCH_PROFIT_BY_ACCOUNT_SUCCESS:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          profit: {
            ...state.portfolioStatistic.profit,
            data: action.payload,
            isFetching: false,
          },
        },
      };
    case investmentConstants.FETCH_PROFIT_BY_ACCOUNT_FAILURE:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          profit: {
            ...state.portfolioStatistic.profit,
            data: {},
            errorMessage: action.payload,
            isFetching: false,
          },
        },
      };
    case investmentConstants.FETCH_VOLATILITY_BY_ACCOUNT_START:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          volatility: {
            ...state.portfolioStatistic.volatility,
            isFetching: true,
            data: {},
          },
        },
      };
    case investmentConstants.FETCH_VOLATILITY_BY_ACCOUNT_SUCCESS:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          volatility: {
            ...state.portfolioStatistic.volatility,
            data: action.payload,
            isFetching: false,
          },
        },
      };
    case investmentConstants.FETCH_VOLATILITY_BY_ACCOUNT_FAILURE:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          volatility: {
            ...state.portfolioStatistic.volatility,
            data: {},
            errorMessage: action.payload,
            isFetching: false,
          },
        },
      };
    case investmentConstants.FETCH_MAX_DRAWDOWN_BY_ACCOUNT_START:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          maxDrawdown: {
            ...state.portfolioStatistic.maxDrawdown,
            isFetching: true,
          },
        },
      };
    case investmentConstants.FETCH_MAX_DRAWDOWN_BY_ACCOUNT_SUCCESS:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          maxDrawdown: {
            ...state.portfolioStatistic.maxDrawdown,
            data: action.payload,
            isFetching: false,
          },
        },
      };
    case investmentConstants.FETCH_MAX_DRAWDOWN_BY_ACCOUNT_FAILURE:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          maxDrawdown: {
            ...state.portfolioStatistic.maxDrawdown,
            data: {},
            errorMessage: action.payload,
            isFetching: false,
          },
        },
      };
    case investmentConstants.FETCH_DRAWDOWN_BY_ACCOUNT_START:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          drawdown: {
            ...state.portfolioStatistic.drawdown,
            isFetching: true,
          },
        },
      };
    case investmentConstants.FETCH_DRAWDOWN_BY_ACCOUNT_SUCCESS:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          drawdown: {
            ...state.portfolioStatistic.drawdown,
            data: action.payload || [],
            isFetching: false,
          },
        },
      };
    case investmentConstants.FETCH_DRAWDOWN_BY_ACCOUNT_FAILURE:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          drawdown: {
            ...state.portfolioStatistic.drawdown,
            data: [],
            errorMessage: action.payload,
            isFetching: false,
          },
        },
      };
    case investmentConstants.CLEAR_DEFAULT_PORT_STAT:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          lastDate: null,
          drawdown: {
            ...state.portfolioStatistic.drawdown,
            data: [],
          },
          maxDrawdown: {
            ...state.portfolioStatistic.maxDrawdown,
            data: {},
          },
          previousReturnGraph: {
            ...state.portfolioStatistic.previousReturnGraph,
            data: [],
          },
        },
      };
    case investmentConstants.FETCH_LAST_DATE_OF_ACCOUNT_NUMBER_SUCCESS:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          lastDate: action.payload,
        },
      };
    case investmentConstants.FETCH_LAST_DATE_OF_ACCOUNT_NUMBER_FAILURE:
      return {
        ...state,
        portfolioStatistic: {
          ...state.portfolioStatistic,
          lastDate: null,
        },
      };

    // LOT
    case investmentConstants.UPDATE_LOT_QUERIES: {
      if (!action.payload || !Object.keys(action.payload).length) {
        return state;
      }

      let updateAttribute = {};
      Object.keys(action.payload).forEach((attribute) => {
        let value = action.payload[`${attribute}`];
        updateAttribute[attribute] = value;
        switch (attribute) {
          case "accountNumber":
            updateAttribute = { ...initialState.lot.queries };
            break;
          case "sortBy":
            if (value === "nav" || value === "riskLevel") {
              updateAttribute["sortType"] =
                state.lot.queries.sortBy === value &&
                state.lot.queries.sortType !== "d"
                  ? "d"
                  : "a";
            } else {
              updateAttribute["sortType"] =
                state.lot.queries.sortBy === value &&
                value &&
                state.lot.queries.sortType !== "a"
                  ? "a"
                  : "d";
            }
            break;
          case "groupType":
            updateAttribute[attribute] = value;
            // ! Uncomment below line to cascading fund type and fund code when update group type.
            // updateAttribute['fundType'] = defaultFundTypeList[0];
            // updateAttribute['fundCode'] = null;
            break;
          case "fundType":
            updateAttribute["fundType"] = value;
            updateAttribute["fundCode"] = null;
            break;
          case "fundCode":
            updateAttribute["fundType"] = null;
            updateAttribute["fundCode"] = value;
            break;
          default:
            updateAttribute[attribute] = value;
            break;
        }
      });

      return {
        ...state,
        lot: {
          ...state.lot,
          queries: {
            ...state.lot.queries,
            ...updateAttribute,
          },
        },
      };
    }
    case investmentConstants.FETCH_LOTS_START:
      return {
        ...state,
        lot: {
          ...state.lot,
          response: {
            ...state.lot.response,
            isFetching: true,
          },
        },
      };
    case investmentConstants.FETCH_LOTS_SUCCESS:
      return {
        ...state,
        lot: {
          ...state.lot,
          response: {
            ...state.lot.response,
            isFetching: false,
            data: action.payload ?? [],
            errorMessage: null,
          },
        },
      };
    case investmentConstants.FETCH_LOTS_FAILURE:
      return {
        ...state,
        lot: {
          ...state.lot,
          response: {
            ...state.lot.response,
            isFetching: false,
            data: [],
            errorMessage: action.payload,
          },
        },
      };
    case investmentConstants.FETCH_NAVS_LOTS_START:
      return {
        ...state,
        lot: {
          ...state.lot,
          navs: {
            ...state.lot.navs,
            isFetching: true,
          },
        },
      };
    case investmentConstants.FETCH_NAVS_LOTS_SUCCESS:
      return {
        ...state,
        lot: {
          ...state.lot,
          navs: {
            ...state.lot.navs,
            isFetching: false,
            data: action.payload,
            errorMessage: null,
          },
        },
      };
    case investmentConstants.FETCH_NAVS_LOTS_FAILURE:
      return {
        ...state,
        lot: {
          ...state.lot,
          navs: {
            ...state.lot.navs,
            isFetching: false,
            data: [],
            errorMessage: action.payload,
          },
        },
      };

    // BOOK
    case investmentConstants.UPDATE_BOOK_QUERIES: {
      if (!action.payload || !Object.keys(action.payload).length) {
        return state;
      }

      let updateAttribute = {};
      Object.keys(action.payload).forEach((attribute) => {
        let value = action.payload[`${attribute}`];
        updateAttribute[attribute] = value;
        switch (attribute) {
          case "accountNumber":
            updateAttribute["funds"] = [];
            break;
          case "sortBy":
            if (value === "nav" || value === "riskLevel") {
              updateAttribute["sortType"] =
                state.book.queries.sortBy === value &&
                state.book.queries.sortType !== "d"
                  ? "d"
                  : "a";
            } else {
              updateAttribute["sortType"] =
                state.book.queries.sortBy === value &&
                value &&
                state.book.queries.sortType !== "a"
                  ? "a"
                  : "d";
            }
            break;
          default:
            updateAttribute[attribute] = value;
            break;
        }
      });

      return {
        ...state,
        book: {
          ...state.book,
          queries: {
            ...state.book.queries,
            ...updateAttribute,
          },
        },
      };
    }
    case investmentConstants.FETCH_BOOKS_START:
      return {
        ...state,
        book: {
          ...state.book,
          response: {
            ...state.book.response,
            isFetching: true,
          },
        },
      };
    case investmentConstants.FETCH_BOOKS_SUCCESS:
      return {
        ...state,
        book: {
          ...state.book,
          response: {
            ...state.book.response,
            data: action.payload ?? [],
            isFetching: false,
            errorMessage: null,
          },
        },
      };
    case investmentConstants.FETCH_BOOKS_FAILURE:
      return {
        ...state,
        book: {
          ...state.book,
          response: {
            ...state.book.response,
            data: undefined,
            isFetching: false,
            errorMessage: action.payload,
          },
        },
      };

    // Dividend
    case investmentConstants.UPDATE_DIVIDEND_QUERIES: {
      if (!action.payload || !Object.keys(action.payload).length) {
        return state;
      }

      let updateAttribute = {};
      Object.keys(action.payload).forEach((attribute) => {
        let value = action.payload[`${attribute}`];
        updateAttribute[attribute] = value;
        switch (attribute) {
          case "accountNumber":
            updateAttribute["funds"] = [];
            break;
          case "sortBy":
            if (value === "nav" || value === "riskLevel") {
              updateAttribute["sortType"] =
                state.dividend.queries.sortBy === value &&
                state.dividend.queries.sortType !== "d"
                  ? "d"
                  : "a";
            } else {
              updateAttribute["sortType"] =
                state.dividend.queries.sortBy === value &&
                value &&
                state.dividend.queries.sortType !== "a"
                  ? "a"
                  : "d";
            }
            break;
          default:
            updateAttribute[attribute] = value;
            break;
        }
      });

      return {
        ...state,
        dividend: {
          ...state.dividend,
          queries: {
            ...state.dividend.queries,
            ...updateAttribute,
          },
        },
      };
    }
    case investmentConstants.FETCH_DIVIDENDS_START:
      return {
        ...state,
        dividend: setIsFetching(state.dividend),
      };
    case investmentConstants.FETCH_DIVIDENDS_SUCCESS:
      return {
        ...state,
        dividend: dividendsData(state.dividend, action.payload),
      };
    case investmentConstants.FETCH_DIVIDENDS_FAILURE:
      return {
        ...state,
        dividend: dividendsError(state.dividend, action.payload),
      };
    case investmentConstants.RESET_INVESTMENT:
      return { ...initialState };
    default:
      return state;
  }
};

export default investmentReducer;
